// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PI94","text":"styles_text__Gzaxb","icon":"styles_icon__qF2Od"};